import { useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import {
  Dialog,
  DialogProps,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

import { Button } from '../../../../../components/Button';
import { useRoute } from '../../../hooks/route';

interface IProps extends DialogProps {
  routeId: number;
  routeName: string;
  onClose: () => void;
}

export const CancelRoute = ({
  routeId,
  routeName,
  onClose,
  ...props
}: IProps) => {
  const { routeCanceled } = useRoute();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    try {
      await routeCanceled(routeId).then(() => {
        enqueueSnackbar('Rota cancelada com sucesso!', {
          variant: 'success',
        });

        onClose();
      });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, [enqueueSnackbar, onClose, routeCanceled, routeId]);

  return (
    <Dialog
      maxWidth="sm"
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      {...props}
    >
      <DialogTitle id="confirmation-dialog-title">
        Cancelar {routeName}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          Deseja realmente cancelar essa rota?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Fechar
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          loading={loading}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
